export const LINKS = {
  maps: "https://www.google.com/maps?kgmid=/g/11vrjhkpq2&hl=en-IN&shem=epsd1,esd2e,ltae,rimspwouoe,sdpie&shndl=30&kgs=d182d68fadf9895d&um=1&ie=UTF-8&fb=1&gl=in&sa=X&geocode=KS9EqvbLvsI7MewdParyCINn&daddr=Shop+Number+9,+%2610+Road,+opposite+Bhairavee+Hotel,+near+Green+Park+Hotel,+Laxman+Park,+Baner,+Pune,+Maharashtra+411069",
  instagram: "https://www.instagram.com/brewing_bistro_baner/?hl=en",
  zomato: "https://www.zomato.com/pune/brewing-bistro-baner",
  zomatoOrder: "https://zomato.onelink.me/xqzv/wen3tsh1",
};

export const IMG = {
  logo: "/assets/logo.jpg",
  neon: "/assets/neon-wall.jpg",
  bar: "/assets/emerald-bar.jpg",
  velvet: "/assets/velvet-nook.jpg",
  slicePull: "/assets/dish-a.jpg",
  cheesePull: "/assets/dish-b.jpg",
  flatlay: "/assets/dish-c.jpg",
  bowl: "/assets/dish-d.jpg",
  table: "/assets/dish-e.jpg",
};

export const NAV = [
  { label: "The Vibe", href: "#vibe", testid: "nav-link-vibe" },
  { label: "Menu", href: "#menu", testid: "nav-link-menu" },
  { label: "Reviews", href: "#reviews", testid: "nav-link-reviews" },
  { label: "Find Us", href: "#visit", testid: "nav-link-location" },
];

export const MARQUEE = [
  "Serving serotonin in Baner",
  "Espresso yourself",
  "Sip slow, vibe high",
  "No bad days here",
  "Good coffee, better company",
  "Walk-ins always welcome",
];

export const ADDRESS =
  "Shop 9 & 10, Baner Road, opposite Bhairavee Hotel, near Green Park Hotel, Laxman Park, Baner, Pune 411069";

export const HOURS = [
  { days: "Mon – Tue, Thu – Sun", time: "9:00 AM – 11:30 PM" },
  { days: "Wednesday", time: "9:00 AM – 11:00 PM" },
];

export const MENU = [
  {
    name: "Neapolitan Pizza",
    category: "Pizzas",
    desc: "Blistered, bubbly crust with tangy tomato and molten cheese — the one Baner keeps coming back for.",
    badge: "Zomato Top Dish",
  },
  {
    name: "Classic Margherita",
    category: "Pizzas",
    desc: "Slow-fermented base, clouds of fresh mozzarella, torn basil. Simple. Perfect. Dangerous.",
    badge: "Crowd Favourite",
  },
  {
    name: "Peri Peri Chicken",
    category: "Mains",
    desc: "Fiery, smoky and completely unapologetic. Comes with a warning you will absolutely ignore.",
    badge: "Zomato Top Dish",
  },
  {
    name: "Cajun Prawns & Mushroom Panini",
    category: "Sandwiches",
    desc: "Grilled ciabatta loaded with cajun prawns, mushrooms and melty cheese — reviewed, raved, repeated.",
    badge: "New Menu Star",
  },
  {
    name: "White Sauce Pasta",
    category: "Pastas",
    desc: "Silky, garlicky, dangerously comforting. Basically a hug in a bowl.",
    badge: "Zomato Top Dish",
  },
  {
    name: "Roasted Harissa Chicken",
    category: "Mains",
    desc: "Char-kissed and harissa-glazed, straight off the new menu Punekars are talking about.",
    badge: "New Menu Star",
  },
  {
    name: "Ros Omelette with Pao",
    category: "All-Day Breakfast",
    desc: "Goan-style spicy gravy meets a fluffy omelette and buttered pao. Breakfast with attitude.",
    badge: "New Menu Star",
  },
  {
    name: "Roasted Beet & Goat Cheese Salad",
    category: "Salads",
    desc: "Fresh, light and prettier than your Instagram grid. Balance, as they say.",
    badge: "Fresh Pick",
  },
  {
    name: "Bistro Hot Chocolate",
    category: "Beverages",
    desc: "“The Hot Chocolate here is amazing!” — an actual customer review, not us bragging.",
    badge: "Review-Approved",
  },
  {
    name: "Blueberry Shake & Iced Coffee",
    category: "Beverages",
    desc: "Served in the most photogenic bottles in Baner. Sip slow, click fast.",
    badge: "Insta Famous",
  },
];

export const REVIEWS = [
  {
    author: "Bhagyashree Satav",
    rating: 5,
    date: "10 days ago",
    text: "The café has a beautiful, cozy ambiance — perfect for a relaxed meal, coffee date, or catching up with friends. The Cajun Prawns & Mushroom Panini was packed with flavour. Definitely worth checking out!",
  },
  {
    author: "Vaishnavi",
    rating: 5,
    date: "one month ago",
    text: "The Hot Chocolate here is amazing!",
  },
  {
    author: "Akshay Daundkar",
    rating: 5,
    date: "4 months ago",
    text: "Best food quality.",
  },
  {
    author: "Ronit Udasi",
    rating: 5,
    date: "15 days ago",
    text: "Wow.",
  },
];

export const KNOWN_FOR = [
  "Fantastic Decoration",
  "Excellent Location",
  "Cooperative Staff",
  "Wonderful Presentation",
  "Nice Concept",
];
